import Icon from '@ant-design/icons'
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

function LifelineIconSvg() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.5"
        y="1.5"
        width="47"
        height="47"
        rx="23.5"
        fill="white"
        stroke="#FE7F00"
        strokeWidth="3"
      />
      <path
        d="M43.293 9.89941L28.1924 25L28.5459 25.3535L43.292 40.1006L40.1006 43.292L25 28.1914L24.6465 28.5449L9.89844 43.292L6.70703 40.1006L21.4551 25.3535L21.8086 25L6.70703 9.89844L9.89941 6.70703L25 21.8076L40.1006 6.70703L43.293 9.89941Z"
        fill="#FE7F00"
        stroke="#FE7F00"
      />
    </svg>
  )
}

export default function LifelineIcon(props: Partial<CustomIconComponentProps>) {
  return <Icon component={() => LifelineIconSvg()} {...props} />
}
